import { cn } from '@/lib/utils';
import { AirlineLogo } from '../shared/AirlineLogo';
import { InfoGrid, InfoItem } from '../shared/InfoGrid';
import { getTravelerName } from '../utils/formatters';
import type { FrequentFlyerCard as FFCardType, Traveler } from '../utils/types';

interface FrequentFlyerCardProps {
  card: FFCardType;
  travelers: Traveler[];
  className?: string;
}

export function FrequentFlyerCard({ card, travelers, className }: FrequentFlyerCardProps) {
  const travelerName = getTravelerName(travelers, card.travelerId);

  return (
    <div
      className={cn(
        'rounded-lg border border-slate-200 bg-white p-4 shadow-sm',
        'hover:shadow-md transition-shadow duration-200',
        className
      )}
    >
      {/* Header with airline logo and card number */}
      <div className="flex items-center gap-3">
        <AirlineLogo airlineCode={card.companyCode} size="lg" />
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-slate-900">{card.companyCode}</span>
            <span className="font-mono text-slate-700">{card.cardNumber}</span>
          </div>
          <span className="text-xs text-slate-400 font-mono">{card.id}</span>
        </div>
      </div>

      {/* Details grid */}
      <div className="mt-4 pt-3 border-t border-slate-100">
        <InfoGrid columns={2}>
          <InfoItem label="Traveler" value={travelerName} />
          <InfoItem label="Tier Level" value={card.tierLevel || '—'} />
          <InfoItem label="Priority" value={card.priorityCode || '—'} />
          <InfoItem label="Alliance Tier" value={card.allianceTierLevel || '—'} />
        </InfoGrid>
      </div>
    </div>
  );
}
